var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBringToFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 418.7 444",
    style: {
      enableBackground: "new 0 0 418.7 444"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 5.12646484375, 0, 0, 5.12646484375, 1509.65,400.25) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_1_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-236.4-58.7c0.8-0.8,0.9-2,0.5-3.5l-14.9-14.3c-1-0.9-2-1.4-2.9-1.5c-0.9,0.1-1.8,0.6-2.8,1.5l-14.9,14.3 c-0.4,1.6-0.2,2.7,0.5,3.5c0.7,0.8,1.9,0.9,3.5,0.5l11-10.7v39.7c0,0.1,0.1,0.2,0.2,0.2c0.8,0.9,1.6,1.3,2.5,1.2 c0.8,0.1,1.7-0.3,2.6-1.2c0,0,0.1-0.1,0.1-0.2v-39.7l11,10.7C-238.3-57.7-237.1-57.9-236.4-58.7 M-214.3-30.8c2-1.6,2-3.4,0-5.3 l-26.4-13.1v6.4l18,8.9l-31,14.9l-30.9-14.9l18-8.9v-6.4L-293-36c-2,1.9-2,3.7,0,5.3l39.2,19L-214.3-30.8 M-214.3-15.7l-9.2-4.5 L-230-17l7.3,3.5l-31,14.9l-30.9-14.9l7.3-3.5l-6.5-3.2l-9.2,4.5c-2,1.9-2,3.7,0,5.3l39.2,19l39.4-19 C-212.3-12-212.3-13.8-214.3-15.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringToFront);
export default __webpack_public_path__ + "static/media/bring_to_front.83ad77a3.svg";
export { ForwardRef as ReactComponent };